export const patientPrep = [
  {
    icon: "ri-file-list-3-line",
    title: "Hekiminizin istediği filmi getirin",
    text: "Diş hekiminizin verdiği istem formunu veya notunu yanınızda getirin. Hangi filmin istendiğini bilmek çekimi hızlandırır.",
  },
  {
    icon: "ri-time-line",
    title: "Randevunuzdan 5 dakika önce gelin",
    text: "Randevunuza birkaç dakika erken gelmeniz, kayıt ve hazırlık işlemlerinin sıra beklemeden tamamlanmasını sağlar.",
  },
  {
    icon: "ri-shirt-line",
    title: "Rahat kıyafet tercih edin",
    text: "Boyun ve çene bölgesini sıkmayan, rahat kıyafetler çekim sırasında pozisyon almanızı kolaylaştırır.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Özel durumları bildirin",
    text: "Hamilelik, kalp pili, kullanılan ilaçlar veya geçirilmiş operasyonlar gibi durumları çekim öncesinde bize mutlaka bildirin.",
  },
];

export const patientDuring = [
  {
    step: "01",
    title: "Kayıt ve hazırlık",
    text: "Randevunuzda kısa kayıt işlemi yapılır; özel durumlarınız not edilir ve çekim için yönlendirilirsiniz.",
  },
  {
    step: "02",
    title: "Pozisyonlama",
    text: "Teknisyenimiz sizi cihaza göre doğru pozisyona yerleştirir. Çene ve baş konumunuz ayarlanır.",
  },
  {
    step: "03",
    title: "Çekim",
    text: "Panoramik ve 2D çekimler yalnızca birkaç saniye, 3D tomografi ise ortalama 9-25 saniye sürer. Bu sırada hareketsiz kalmanız yeterlidir.",
  },
  {
    step: "04",
    title: "Kontrol",
    text: "Görüntü aynı seansta ekranda kontrol edilir. Netlik yeterli değilse tekrar çekilir; ek ücret alınmaz.",
  },
];

export const patientAfter = [
  {
    icon: "ri-check-double-line",
    title: "Ekstra bir işlem yok",
    text: "Çekim sonrasında özel bir bakım gerekmez. Günlük rutininize hemen dönebilirsiniz.",
  },
  {
    icon: "ri-send-plane-line",
    title: "Görüntüler hekiminize gider",
    text: "Görüntü ve rapor, talep doğrultusunda diş hekiminize dijital olarak aynı gün iletilir.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Bilgileriniz sizde kalır",
    text: "Görüntülerinizin bir kopyasını talep etmeniz hâlinde dijital ortamda sizinle paylaşabiliriz.",
  },
];

export const patientSafetyCards = [
  {
    icon: "ri-shield-check-line",
    title: "Düşük doz protokolü",
    text: "Dijital panoramik ve CBCT cihazları, klasik yöntemlere göre çok daha düşük radyasyon dozuyla çalışır. ALARA prensibiyle gereksiz dozdan kaçınılır.",
  },
  {
    icon: "ri-parent-line",
    title: "Hamilelik ve özel durumlar",
    text: "Hamilelikte görüntüleme mutlaka hekim onayıyla yapılır. Çekim öncesi durumu bildirin; gerekirse ek koruyucu önlem alınır veya çekim ertelenir.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Mahremiyet ve KVKK",
    text: "Görüntü ve raporlarınız hasta mahremiyeti ve KVKK kapsamında güvenle saklanır; yalnızca ilgili hekimle paylaşılır.",
  },
];

export const patientFaqs = [
  {
    question: "Çekim ağrılı mıdır?",
    answer:
      "Hayır. Dental görüntüleme ağrısız bir işlemdir. Çekim sırasında tek yapmanız gereken kısa süre hareketsiz kalmaktır.",
  },
  {
    question: "Ne kadar sürede tamamlanır?",
    answer:
      "Merkezde geçirdiğiniz toplam süre — hazırlık, çekim ve kontrol dahil — genellikle 10-15 dakikadır. Çekimin kendisi birkaç saniye ile 25 saniye arasında değişir.",
  },
  {
    question: "Randevusuz gelebilir miyim?",
    answer:
      "Merkezimiz randevuyla çalışır. WhatsApp veya telefondan genellikle aynı gün için uygun saat bulunur; böylece beklemeden işleminizi tamamlayabilirsiniz.",
  },
  {
    question: "Sonuçları ben de alabilir miyim?",
    answer:
      "Görüntü ve rapor öncelikle diş hekiminize iletilir. Kendi kopyanızı talep etmeniz hâlinde dijital ortamda sizinle de paylaşabiliriz.",
  },
  {
    question: "Çocuğumu getirebilir miyim?",
    answer:
      "Evet. Çocuk hastalar için özel görüntü alanı ve düşük doz protokolü uygularız. Randevu alırken çocuk hastası olduğunu belirtmeniz yeterlidir.",
  },
  {
    question: "Ücretlendirme nasıl yapılır?",
    answer:
      "Ücret çekim türüne göre değişir. Net bilgi için diş hekiminizin istediği filmi WhatsApp'tan yazabilirsiniz. Nakit, banka havalesi ve kredi kartı kabul edilir.",
  },
];